// PersonalStylist.js
// Gestione popup Personal Stylist con Embedded Messaging (embeddedservice_bootstrap)
import { trapFocusOnModal, removeTrapFocusOnModal } from '../utils/TrapFocus';
import Component from '../abstracts/Component';

export default class PersonalStylistComponent extends Component {
  // common selectors, overridable
  get SELECTORS() {
    return {
      bannerSelector: '.live-chat-personal-stylist-cta__wrapper',
      startChatSelector: '.start-chat, .start-whatsapp',
      closeBtnSelector: '.live-chat-personal-stylist-cta__wrapper .vex-close',
      // Personal Stylist specific selectors
      personalStylistStartChat: '#liveChatPSLaunch',
    };
  }

  get CONSTANTS() {
    return {
      HIDE_COOKIE_KEY: 'ps_button_hide',
      TRIGGER_TIME: 5000,
    };
  }

  constructor() {
    super();
    this.triggerTime = this.CONSTANTS.TRIGGER_TIME;
    this.hideCookieKey = this.CONSTANTS.HIDE_COOKIE_KEY;
    this.trapFocusHandler = null;
    this.lastActiveElement = null;
    this.isPopupAccessibilityActive = false;
    this.popupObserver = null;
    this.handleEscKey = null;
  }

  logCookieStatus() {
    const cookiePresent = this.isHiddenByCookie();
    console.log(
      `[PersonalStylist][DEBUG] Cookie '${this.hideCookieKey}' presente:`,
      !!cookiePresent,
      'Valore:',
      cookiePresent
    );
  }

  render() {
    this.log('rendering...');
    this.logCookieStatus();
    this.init();
  }

  init() {
    this.banner = document.querySelector(this.SELECTORS.bannerSelector);
    console.log('[PersonalStylist][DEBUG] this.banner:', this.banner);
    this.startChatBtn = this.banner
      ? this.banner.querySelector(this.SELECTORS.startChatSelector)
      : null;
    console.log(
      '[PersonalStylist][DEBUG] this.startChatBtn:',
      this.startChatBtn
    );
    this.closeBtn = this.banner
      ? this.banner.querySelector(this.SELECTORS.closeBtnSelector)
      : null;
    console.log('[PersonalStylist][DEBUG] this.closeBtn:', this.closeBtn);
    // Mostra il banner dopo triggerTime se non nascosto da cookie
    if (this.banner && !this.isHiddenByCookie()) {
      console.log(
        '[PersonalStylist][DEBUG] Banner trovato e cookie non presente, timer avviato:',
        this.triggerTime
      );

      this.personalStylistStartChat = document.querySelector(
        this.SELECTORS.personalStylistStartChat
      );
      console.log(
        '[PersonalStylist][DEBUG] this.personalStylistStartChat:',
        this.personalStylistStartChat
      );
      setTimeout(() => {
        console.log(
          '[PersonalStylist][DEBUG] Timeout scaduto, rendo visibile il banner'
        );
        this.banner.classList.remove('d-none');
        this.setupEvents();
        this.setupAccessibility();
      }, this.triggerTime);
    } else {
      if (!this.banner) {
        console.warn('[PersonalStylist][DEBUG] Banner NON trovato nel DOM');
      }
      if (this.isHiddenByCookie()) {
        console.warn(
          '[PersonalStylist][DEBUG] Cookie presente, banner NON verrà mostrato'
        );
      }
    }
  }

  setupEvents() {
    // Avvia Embedded Messaging al click su start chat/whatsapp
    if (this.startChatBtn) {
      this.startChatBtn.addEventListener('click', e => {
        e.stopPropagation();
        this.startEmbeddedMessaging();
        this.hideBanner();
        this.setHideCookie();
      });
    }
    // Chiudi banner e imposta cookie
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => {
        this.hideBanner();
        this.setHideCookie();
      });
    }
    // Gestione click su banner per avviare chat come Personal Stylist
    if (this.personalStylistStartChat) {
      console.log(
        '[PersonalStylist][DEBUG] personalStylistStartChat trovato, impostando evento click'
      );
      const prechatFields = {
        Type: {
          value: 'Personal_Stylist',
          isEditableByEndUser: true,
        },
      };
      this.personalStylistStartChat.addEventListener('click', e => {
        console.log(
          '[PersonalStylist][DEBUG] personalStylistStartChat click, avvio chat come Personal Stylist'
        );
        e.preventDefault();
        const chatAPI = window.embeddedservice_bootstrap;
        chatAPI.prechatAPI.setVisiblePrechatFields(prechatFields);
        chatAPI.utilAPI.launchChat();
      });
    }
  }

  setupAccessibility() {
    if (!this.banner || !this.closeBtn || !this.startChatBtn) return;
    // ESC key listener
    this.handleEscKey = e => {
      if (e.key === 'Escape' && !this.banner.classList.contains('d-none')) {
        this.closeBtn.click();
      }
    };
    document.addEventListener('keydown', this.handleEscKey);
    // MutationObserver per gestire focus trap e aria
    this.popupObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          const isVisible = !this.banner.classList.contains('d-none');
          if (isVisible && !this.isPopupAccessibilityActive) {
            this.activatePopupAccessibility();
          } else if (!isVisible && this.isPopupAccessibilityActive) {
            this.deactivatePopupAccessibility();
          }
        }
      });
    });
    this.popupObserver.observe(this.banner, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  activatePopupAccessibility() {
    if (!this.banner || this.isPopupAccessibilityActive) return;
    this.lastActiveElement = document.activeElement;
    this.banner.setAttribute('aria-hidden', 'false');
    this.trapFocusHandler = trapFocusOnModal(this.banner);
    requestAnimationFrame(() => {
      if (this.startChatBtn) {
        this.startChatBtn.focus();
      }
    });
    this.isPopupAccessibilityActive = true;
  }

  deactivatePopupAccessibility() {
    if (!this.banner || !this.isPopupAccessibilityActive) return;
    if (this.trapFocusHandler) {
      removeTrapFocusOnModal(this.banner, this.trapFocusHandler);
      this.trapFocusHandler = null;
    }
    this.banner.setAttribute('aria-hidden', 'true');
    if (this.lastActiveElement) {
      this.lastActiveElement.focus();
      this.lastActiveElement = null;
    }
    this.isPopupAccessibilityActive = false;
  }

  startEmbeddedMessaging() {
    // Inizializza Embedded Messaging solo se disponibile
    if (
      window.embeddedservice_bootstrap &&
      typeof window.embeddedservice_bootstrap.init === 'function'
    ) {
      if (typeof window.initEmbeddedMessaging === 'function') {
        window.initEmbeddedMessaging();
      } else {
        console.warn('[PersonalStylist] initEmbeddedMessaging non trovato');
      }
    } else {
      console.error(
        '[PersonalStylist] embeddedservice_bootstrap non disponibile'
      );
    }
  }

  hideBanner() {
    if (this.banner) {
      this.banner.classList.add('hidden');
      this.deactivatePopupAccessibility();
    }
  }

  setHideCookie() {
    document.cookie = `${this.hideCookieKey}=true; path=/; max-age=86400`;
  }

  isHiddenByCookie() {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith(this.hideCookieKey + '='));
  }
}
